import SEO from './SEO';

const ContactSEO = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "NABAZAT AL QALB",
    "description": "Contact NABAZAT AL QALB for medical supplies and healthcare solutions in Erbil, Iraq. Get in touch with our expert team for quality medical equipment and pharmaceutical needs.",
    "url": "https://nabazatalqalb.com/contact",
    "logo": "https://nabazatalqalb.com/logo512.png",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Erbil",
      "addressRegion": "Arbil",
      "addressCountry": "IQ"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": ["English", "Arabic", "Kurdish"],
        "telephone": "+964-XXX-XXX-XXXX"
      },
      {
        "@type": "ContactPoint",
        "contactType": "sales",
        "availableLanguage": ["English", "Arabic", "Kurdish"],
        "telephone": "+964-XXX-XXX-XXXX"
      }
    ],
    "sameAs": [
      "https://facebook.com/nabazatalqalb",
      "https://twitter.com/nabazatalqalb",
      "https://linkedin.com/company/nabazatalqalb"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "Iraq"
    },
    "serviceType": "Medical Supplies and Healthcare Solutions",
    "openingHours": "Mo-Fr 08:00-18:00, Sa 08:00-14:00"
  };

  return (
    <SEO
      title="Contact"
      description="Contact NABAZAT AL QALB for medical supplies and healthcare solutions in Erbil, Iraq. Reach our expert team for quality medical equipment, pharmaceuticals, and healthcare solutions. Call us today!"
      keywords="contact NABAZAT AL QALB, medical supplies contact, healthcare contact Erbil Iraq, medical equipment contact, pharmaceutical contact, medical company contact, healthcare solutions contact"
      url="https://nabazatalqalb.com/contact"
      structuredData={structuredData}
    />
  );
};

export default ContactSEO; 